import Popups from './popups';
import { getCookie, setCookie } from './utils';

document.addEventListener( 'DOMContentLoaded', function() {
	const popup = document.getElementById( 'subscribe-popup' );
	if ( ! popup ) {
		return;
	}

	const storedExpiry = getCookie( 'subscribe-cta-closed' );
	if ( storedExpiry && parseInt( storedExpiry, 10 ) > Math.round( Date.now() / 1000 ) ) {
		return;
	}

	const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	const hasFinePointer = typeof window.matchMedia === 'function' && ( window.matchMedia( '(pointer: fine)' ).matches || window.matchMedia( '(any-pointer: fine)' ).matches );
	if ( isTouchDevice && ! hasFinePointer ) {
		return;
	}

	const rawDelay = popup.dataset.delay || '5000';
	const delay = Number.isNaN( Number( rawDelay ) ) ? 5000 : parseInt( rawDelay, 10 );

	const exit_event = ( e ) => {
		if ( e.toElement || e.relatedTarget ) {
			return;
		}

		if ( e.clientY > 5 ) {
			return;
		}

		document.removeEventListener( 'mouseout', exit_event );

		Popups.show( {
			isClosable: true,
			type: 'inline',
			src: '#subscribe-popup',
			size: 'medium',
			parentClass: 'subscribe-popup-container',
		} );

		document.querySelector( '.subscribe-popup-container button.js-site-popup-close' )?.addEventListener( 'click', () => {
			setCookie( 'subscribe-cta-closed', Math.round( new Date().getTime() / 1000 ) + ( 7 * 24 * 3600 ), 7 );
		} );
		document.querySelector( '#newsletter-subscribe-popup-form' )?.addEventListener( 'submit', () => {
			Popups.hide();
			setCookie( 'subscribe-cta-closed', Math.round( new Date().getTime() / 1000 ) + ( 30 * 24 * 3600 ), 30 );
		} );
	};

	setTimeout( () => {
		document.addEventListener( 'mouseout', exit_event );
	}, delay );
} );
